<template>
  <div v-if="readOnly">
    <div v-if="!model.properties.dropdown" class="mb-6">
      <!--Flat-->
      <div v-if="!model.properties.multiLevel">
        <div v-for="(item, index) in model.properties.selectable" :key="index">
          <div v-if="this.isMultiSelected(item.value)">
            <CustomCheckbox :cbxId="item.value"
                            :cbxValue="item.value"
                            :cbxDisabled="true"
                            :cbxLabel="item.text"
                            v-model="multiSelected"/>
          </div>
        </div>
      </div>
      <!--Multilevel-->
      <div v-else v-for="(item, index) in model.properties.selectable" :key="index">
        <div v-for="subItem in item.children" :key="subItem.value">
          <div v-if="this.isMultiSelected(subItem.value)">
            <CustomCheckbox :cbxId="subItem.value"
                            :cbxValue="subItem.value"
                            :cbxDisabled="true"
                            :cbxLabel="subItem.text"
                            v-model="multiSelected"/>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--Edit mode-->
  <div v-else>
    <div v-if="!model.properties.dropdown" class="mb-6">
      <!--Flat-->
      <div v-if="!model.properties.multiLevel">
        <div v-for="(item, index) in model.properties.selectable" :key="index">
          <CustomCheckbox
            :cbxId="item.value"
            :cbxValue="item.value"
            :cbxLabel="item.text"
            v-model="multiSelected"
            @change="save"
          />
        </div>
      </div>
      <!--Multi level-->
      <div v-else v-for="(item, index) in model.properties.selectable" :key="index" class="mb-2">
        <span class="font-bold">{{ item.text }}</span>
        <div v-for="subItem in item.children" :key="subItem.value">
          <CustomCheckbox
            :cbxId="subItem.value"
            :cbxValue="subItem.value"
            :cbxLabel="subItem.text"
            v-model="multiSelected"
            @change="save"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      multiSelected: this.model.properties.multiSelected === null ? [] : this.model.properties.multiSelected,
      selectable: this.model.properties.selectable,
    };
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  components: {},
  methods: {
    isMultiSelected(value) {
      const isSelected = this.multiSelected.filter((item) => {
        if (item === value) {
          return true;
        }
        return false;
      });
      return isSelected.length > 0;
    },
    save() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.model.contentGuid,
          value: this.multiSelected,
          type: this.type,
          pageId: this.pageId,
          relationRule: this.model.properties.relationRule,
        }),
      };
      const self = this;
      this.isSaving = true;
      fetch(`${window.location.origin}/api/schema/SaveSchemaItem`, requestOptions)
        .then(() => {
          this.$emit('onSave');
          this.$emit('getSchema');
        }).then(() => {
        self.isSaving = false;
        this.$toast.open({
          message: 'Lagret',
          type: 'success',
          dismissible: true,
        });
      });
    },
  },
};
</script>
